module.exports = __webpack_public_path__ + "img/larke.a37c4b81.a37c4b81.png";